import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-xs-investments-dashboard',
  templateUrl: './xs-investments-dashboard.component.html',
  styleUrls: ['./xs-investments-dashboard.component.scss'],
})
export class XsInvestmentsDashboardComponent implements OnInit {
  showing: boolean;
  constructor() {}

  ngOnInit() {}
}
